export default {"src":"/_next/static/media/google.ac7dc63d.svg","height":30,"width":88,"blurWidth":0,"blurHeight":0};